import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	text-align: center;
	color: ${CSSVars.black};

	.hero-wrapper {
		background: url(/assets/hero-bg.webp);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: center 0%;
		color: ${CSSVars.white};
		position: relative;

		&::after {
			content: '';
			position: absolute;
			left: -100%;
			right: -100%;
			background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, black 100%);
			bottom: 0;
			z-index: 2;
			height: 150px;
		}

		@media screen and (max-width: ${CSSVars.breakpointLG}) {
			&::after {
				height: 350px;
			}
		}

		.inner-wrapper {
			padding: 80px 20px 250px;

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				padding: 130px 40px 300px;

				&.ai-hero {
					padding: 130px 40px 130px;
				}
			}

			h1 {
				margin: 0 auto;
				font-size: ${CSSVars.fontSize2XL};
				max-width: 750px;
				margin-bottom: 20px;

				background: linear-gradient(277deg, #fff 48.61%, #808aad 109.97%);
				background-clip: text;
				color: transparent;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSize3XL};
				}
			}

			h2 {
				margin: 0 auto;
				font-size: ${CSSVars.fontSizeLG};
				max-width: 780px;
				font-weight: 300;
			}

			a {
				margin-top: 30px;
			}

			.prompt-footer {
				margin-top: 20px;
				font-size: 14px;
				color: #d1d1d1;
				z-index: 5;
				position: relative;

				a {
					color: #fff;
					text-decoration: none;
					margin: 0;
					font-weight: 500;

					&:hover {
						text-decoration: underline;
					}
				}
			}
		}

		.hero-img-wrapper {
			margin-top: -300px;
		}
	}
`;
